/**
 * create by huangjianlin  2020-10-13 10:33
 */
import React from 'react'
import { Modal, Table } from 'antd'
import { changeStringTime2 } from '../../../util'

export default class extends React.Component {
  render() {
    const { visible, list } = this.props

    //套餐消费
    const columnsMeal = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '流水号',
        dataIndex: 'serial_number',
        key: 'serial_number',
      },
      {
        title: '账户',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: '支付时间',
        dataIndex: 'create_time',
        key: 'create_time',
        render: (text) => {
          return changeStringTime2(text)
        },
      },
      {
        title: '支付方式',
        dataIndex: 'payment_type',
        key: 'payment_type',
      },
      {
        title: '金额',
        dataIndex: 'amount',
        key: 'amount',
      },
    ]

    let prices = 0
    list.forEach((item) => {
      prices += +item.amount
    })

    return (
      <div>
        <Modal
          title="消费详情"
          visible={visible}
          onOk={this.props.handleOk}
          onCancel={this.props.handleCancel}
          width="1000px"
        >
          <p>套餐消费</p>
          <Table
            rowKey="id"
            columns={columnsMeal}
            dataSource={list}
            size="middle"
          />
          <p>付款金额: ￥{prices}</p>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubBusiness/component/modalMeal.js